import React from "react";
import PropTypes from "prop-types";
import {
  Provider,
  Button,
  Flex,
  Text,
  Segment,
} from "@fluentui/react-northstar";
import Constants from "../../../constants/text-constants";
import RegistrationToggle from "../../atoms/registrationToggle";
import { useMst } from "../../../hooks/useMst";
import { observer } from "mobx-react";
import LocationDropDown from "../../molecules/LocationDropDown";
import ClickableLinkBtn from "../../atoms/ClickableLinkBtn";

const HeaderMenu = observer((props) => {
  const {
    signOutClicked,
    settingsClicked,
    currentUser,
    setRegistered,
    locations,
    setLocation,
  } = props;

  const { permissionStore } = useMst();

  const hasPermissions = permissionStore.havePermissions("Registration", [
    "Get",
    "SetStatus",
  ]);

  const hasPermissionsLocation = permissionStore.havePermissions("Locations", [
    "Change",
    "GetAll",
  ]);

  const hasSetRegNoPermissions = permissionStore.havePermissions(
    "Registration",
    ["CngRegNo"]
  );

  const toggle = hasPermissions ? (
    <RegistrationToggle
      checked={currentUser.agent.registered}
      onChange={setRegistered}
      data-testid="registrationToggle"
    />
  ) : null;

  const locationCode =
    currentUser.agent && currentUser.agent.locationCode
      ? currentUser.agent.locationCode.code
      : null;
  const phoneNumber = currentUser.agent ? currentUser.agent.phoneNumber : null;

  const locationDropDown =
    hasPermissionsLocation || hasSetRegNoPermissions ? (
      <LocationDropDown
        locations={locations}
        currentLocationCode={locationCode}
        phoneNumber={phoneNumber}
        onChange={setLocation}
      />
    ) : null;

  return (
    <Provider.Consumer
      render={(theme) => (
        <Segment
          className={"header-menu segment " + theme.siteVariables.themeString}
          data-testid="headerMenu"
        >
          <Flex column gap="gap.medium" fill hAlign="start">
            <Flex className="registration-toggle">{toggle}</Flex>
            {locationDropDown}
            <Flex column>
              <Button
                data-testid="settingsBtn"
                text
                content={Constants.SETTINGS}
                onClick={settingsClicked}
                className="non-selectable header-button"
              />
              <ClickableLinkBtn
                  testId="helpBtn"
                  url={Constants.TELEWARE_HELP_LINK}
                  text={Constants.HELP_AND_SUPPORT}
              />
            </Flex>
            <Button
              data-testid="signOutBtn"
              text
              content={Constants.SIGN_OUT}
              onClick={signOutClicked}
              className="non-selectable header-button"
            />
            <Text
              className="versionText"
              data-testid="versionText"
              content={Constants.BUILD_NUMBER_TEXT}
            />
          </Flex>
        </Segment>
      )}
    ></Provider.Consumer>
  );
});

HeaderMenu.propTypes = {
  signOutClicked: PropTypes.func,
  settingsClicked: PropTypes.func,
  setRegistered: PropTypes.func,
  currentUser: PropTypes.object,
  locations: PropTypes.array,
  setLocation: PropTypes.func,
};

HeaderMenu.defaultProps = {
  currentUser: {},
  locations: [],
};

export default HeaderMenu;
